<div id="dashboard">
  <main>
    <div class="container">
      <div class="row dashboard-wrapper">
        <aside class="sidebar">
          <div class="filters" (click)="toggleFilterPane()">
            @if (!isShowingFilters) {
              <hyperkit-typography variant="h5" align="left" color="primary">
                Filters
              </hyperkit-typography>
            }
            <i class="k-icon k-font-icon k-i-arrow-chevron-left"></i>
          </div>
          <cyborg-all-active-filters></cyborg-all-active-filters>
          <div class="section library">
            <hyperkit-typography
              variant="body"
              size="lg"
              align="left"
              color="primary"
              >Library</hyperkit-typography
            >
            <ul>
              <li>
                <hyperkit-checkbox
                  (click)="onLibraryFilter(cyborgIndexEnum.CYBORG_COLLECTIONS)"
                  [checked]="
                    (searchState$ | async).library.includes(
                      cyborgIndexEnum.CYBORG_COLLECTIONS
                    ) && (searchState$ | async).touched == true
                  "
                  label="Hunt Package Collections"
                >
                </hyperkit-checkbox>
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="inactive"
                  >{{ collectionCount }}</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-checkbox
                  (click)="onLibraryFilter(cyborgIndexEnum.CYBORG_USE_CASES)"
                  [checked]="
                    (searchState$ | async).library.includes(
                      cyborgIndexEnum.CYBORG_USE_CASES
                    ) && (searchState$ | async).touched == true
                  "
                  label="Hunt Packages"
                >
                </hyperkit-checkbox>
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="inactive"
                  >{{ huntPackageCount }}</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-checkbox
                  (click)="
                    onLibraryFilter(cyborgIndexEnum.CYBORG_THREAT_PROFILES)
                  "
                  [checked]="
                    (searchState$ | async).library.includes(
                      cyborgIndexEnum.CYBORG_THREAT_PROFILES
                    ) && (searchState$ | async).touched == true
                  "
                  label="Threat Profiles"
                >
                </hyperkit-checkbox>
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="inactive"
                  >{{ profileCount }}</hyperkit-typography
                >
              </li>
            </ul>
          </div>

          <div class="section community" *ngIf="isTrial$ | async">
            <hyperkit-typography
              variant="body"
              size="lg"
              align="left"
              color="primary"
              >Community</hyperkit-typography
            >
            <ul>
              <li>
                <hyperkit-checkbox
                  (click)="onCommunity()"
                  [checked]="(searchState$ | async).community"
                  label="Community Accessible"
                >
                </hyperkit-checkbox>
              </li>
            </ul>
          </div>

          <div class="section mitre">
            <hyperkit-typography
              display="block"
              variant="body"
              size="lg"
              align="left"
              color="primary"
              >MITRE</hyperkit-typography
            >
            <hyperkit-search-input
              placeholder="Search MITRE"
              (textChange)="onMitreSearch($event)"
            ></hyperkit-search-input>
            @for (tag of filteredMitre; track tag) {
              <cyborg-filter
                [filterData]="tag"
                [events]="mitreTagsSubject"
              ></cyborg-filter>
            }
          </div>

          <div class="section relevant">
            <hyperkit-typography
              variant="body"
              size="lg"
              align="left"
              color="primary"
              >Goals</hyperkit-typography
            >
            @for (tag of filteredGoals; track tag) {
              <cyborg-filter [filterData]="tag"></cyborg-filter>
            }

            <hyperkit-typography
              variant="body"
              size="lg"
              align="left"
              color="primary"
              >Tools</hyperkit-typography
            >
            @for (tag of filteredTools; track tag) {
              <cyborg-filter [filterData]="tag"></cyborg-filter>
            }

            <hyperkit-typography
              variant="body"
              size="lg"
              align="left"
              color="primary"
              >Platform Types</hyperkit-typography
            >
            @for (tag of filteredPlatformTypes; track tag) {
              <cyborg-filter [filterData]="tag"></cyborg-filter>
            }

            <hyperkit-typography
              variant="body"
              size="lg"
              align="left"
              color="primary"
              >Dependencies</hyperkit-typography
            >
            @for (tag of filteredDependencyTypes; track tag) {
              <cyborg-filter [filterData]="tag"></cyborg-filter>
            }
          </div>

          <div class="section relevant">
            <hyperkit-typography
              variant="body"
              size="lg"
              align="left"
              color="primary"
              >Contextual Tagging</hyperkit-typography
            >
            <hyperkit-search-input
              placeholder="Search tags"
              (textChange)="onContextualSearch($event)"
            ></hyperkit-search-input>
            @for (tag of filteredTags; track tag) {
              <cyborg-filter
                [filterData]="tag"
                [events]="contextualTagsSubject"
              ></cyborg-filter>
            }
          </div>

          <div class="section last-updated">
            <hyperkit-typography
              variant="body"
              size="lg"
              align="left"
              color="primary"
              >Last Updated</hyperkit-typography
            >
            <ul>
              <li>
                <div class="radio">
                  <hyperkit-radio-button
                    name="last_updated"
                    value="1"
                    text="1 Day ago"
                    (click)="onLastUpdated($event.currentTarget)"
                  >
                  </hyperkit-radio-button>
                </div>
              </li>
              <li>
                <div class="radio">
                  <hyperkit-radio-button
                    name="last_updated"
                    value="7"
                    text="7 Days ago"
                    (click)="onLastUpdated($event.currentTarget)"
                  >
                  </hyperkit-radio-button>
                </div>
              </li>
              <li>
                <div class="radio">
                  <hyperkit-radio-button
                    name="last_updated"
                    value="45"
                    text="45 Days ago"
                    (click)="onLastUpdated($event.currentTarget)"
                  >
                  </hyperkit-radio-button>
                </div>
              </li>
              <li>
                <div class="radio">
                  <hyperkit-radio-button
                    name="last_updated"
                    value="90"
                    text="90 Days ago"
                    (click)="onLastUpdated($event.currentTarget)"
                  >
                  </hyperkit-radio-button>
                </div>
              </li>
            </ul>
          </div>
        </aside>
        <div class="main-content" #mainContent>
          <form [formGroup]="searchForm" (submit)="onSearch()">
            <hyperkit-search-input
              class="hyperkit-component"
              placeholder="Search mitre, actors, tags etc..."
              (search)="onSearch()"
              formControlName="search"
            ></hyperkit-search-input>
          </form>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </main>
</div>
